module.exports = __webpack_public_path__ + "static/contact-5e042944f16f7bf90db9e9bdcead6b4f.jpg";